import React from "react";

const Footer = () => {
  return (
    

<footer class="bg-[#1A1A1A] ">
    <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div class="md:flex md:justify-between">
          <div class="mb-6 md:mb-0">
              <a href="#" class="flex items-center">
                  <img src="lum-logo.png" class="h-16 me-3" alt="Lumiere Logo" />
              </a>
          </div>
          <div className="flex">
            <div class="grid grid-cols-1 gap-8 sm:gap-6 sm:grid-cols-2">
                <div>
                    <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Страницы</h2>
                    <ul class="text-gray-300 font-extralight">
                        <li class="mb-2">
                            <a href="#" class="hover:underline">Тарифы</a>
                        </li>
                        <li class="mb-2">
                            <a href="#" class="hover:underline">Сервисы</a>
                        </li>
                        <li class="mb-2">
                            <a href="#" class="hover:underline">Новости</a>
                        </li>
                        <li class="mb-2">
                            <a href="#" class="hover:underline">Наш адрес</a>
                        </li>
                    </ul>
                </div>
                
                <div>
                    <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Режим работы</h2>
                    <ul class="text-gray-300 font-medium">
                        <li class="mb-4">
                            <h1 >Каждый день (7 AM - 23 PM)</h1>
                        </li>
                        
                    </ul>
                </div>
            </div>

          </div>
          
      </div>
      <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
      <div class="sm:flex sm:items-center sm:justify-between">
          <span class="text-sm text-gray-300 sm:text-center ">© 2025 <a href="#" class="hover:underline">Lumiere™</a>. All Rights Reserved.
          </span>
          <div class="flex mt-4 sm:justify-center sm:mt-0">
              <a href="#" class="text-gray-300 hover:text-gray-900 dark:hover:text-white ms-5">
                  <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 25">
                        <path fill-rule="evenodd" d="M17.34,5.46h0a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,17.34,5.46Zm4.6,2.42a7.59,7.59,0,0,0-.46-2.43,4.94,4.94,0,0,0-1.16-1.77,4.7,4.7,0,0,0-1.77-1.15,7.3,7.3,0,0,0-2.43-.47C15.06,2,14.72,2,12,2s-3.06,0-4.12.06a7.3,7.3,0,0,0-2.43.47A4.78,4.78,0,0,0,3.68,3.68,4.7,4.7,0,0,0,2.53,5.45a7.3,7.3,0,0,0-.47,2.43C2,8.94,2,9.28,2,12s0,3.06.06,4.12a7.3,7.3,0,0,0,.47,2.43,4.7,4.7,0,0,0,1.15,1.77,4.78,4.78,0,0,0,1.77,1.15,7.3,7.3,0,0,0,2.43.47C8.94,22,9.28,22,12,22s3.06,0,4.12-.06a7.3,7.3,0,0,0,2.43-.47,4.7,4.7,0,0,0,1.77-1.15,4.85,4.85,0,0,0,1.16-1.77,7.59,7.59,0,0,0,.46-2.43c0-1.06.06-1.4.06-4.12S22,8.94,21.94,7.88ZM20.14,16a5.61,5.61,0,0,1-.34,1.86,3.06,3.06,0,0,1-.75,1.15,3.19,3.19,0,0,1-1.15.75,5.61,5.61,0,0,1-1.86.34c-1,.05-1.37.06-4,.06s-3,0-4-.06A5.73,5.73,0,0,1,6.1,19.8,3.27,3.27,0,0,1,5,19.05a3,3,0,0,1-.74-1.15A5.54,5.54,0,0,1,3.86,16c0-1-.06-1.37-.06-4s0-3,.06-4A5.54,5.54,0,0,1,4.21,6.1,3,3,0,0,1,5,5,3.14,3.14,0,0,1,6.1,4.2,5.73,5.73,0,0,1,8,3.86c1,0,1.37-.06,4-.06s3,0,4,.06a5.61,5.61,0,0,1,1.86.34A3.06,3.06,0,0,1,19.05,5,3.06,3.06,0,0,1,19.8,6.1,5.61,5.61,0,0,1,20.14,8c.05,1,.06,1.37.06,4S20.19,15,20.14,16ZM12,6.87A5.13,5.13,0,1,0,17.14,12,5.12,5.12,0,0,0,12,6.87Zm0,8.46A3.33,3.33,0,1,1,15.33,12,3.33,3.33,0,0,1,12,15.33Z" clip-rule="evenodd"/>
                    </svg>
                  <span class="sr-only">Instagram</span>
              </a>
              
              <a href="#" class="text-gray-300 hover:text-gray-900 dark:hover:text-white ms-5">
                  <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 17">
                    <path fill-rule="evenodd" d="M16.398 2.35408C15.7981 2.61946 15.1648 2.78532 14.4981 2.88484C15.1648 2.48677 15.6981 1.8565 15.9314 1.09353C15.2981 1.45843 14.5981 1.72381 13.8315 1.88967C13.2315 1.2594 12.3649 0.861328 11.4316 0.861328C9.63174 0.861328 8.16516 2.32091 8.16516 4.11221C8.16516 4.37759 8.19849 4.6098 8.26515 4.842C5.5653 4.70931 3.13211 3.41559 1.49886 1.42526C1.23221 1.92284 1.06556 2.4536 1.06556 3.0507C1.06556 4.17856 1.63219 5.17373 2.53214 5.77083C1.99884 5.73765 1.49886 5.60497 1.03222 5.37276V5.40593C1.03222 6.9982 2.16549 8.32509 3.66541 8.62364C3.39876 8.68999 3.09878 8.72316 2.79879 8.72316C2.5988 8.72316 2.36548 8.68999 2.16549 8.65682C2.5988 9.95053 3.79874 10.9125 5.23199 10.9125C4.09872 11.775 2.6988 12.3058 1.16555 12.3058C0.898898 12.3058 0.632246 12.3058 0.398926 12.2726C1.86551 13.2014 3.56542 13.7322 5.43198 13.7322C11.465 13.7322 14.7648 8.75633 14.7648 4.44393C14.7648 4.31125 14.7648 4.14538 14.7648 4.0127C15.3981 3.58146 15.9647 3.01753 16.398 2.35408Z" clip-rule="evenodd"/>
                </svg>
                  <span class="sr-only">Twitter</span>
              </a>
              <a href="#" class="text-gray-300 hover:text-gray-900 dark:hover:text-white ms-5">
                  <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M14.5 1.5L0.5 6.5L4.5 8.5L10.5 4.5L6.5 9.5L12.5 13.5L14.5 1.5Z" clip-rule="evenodd"/>
                  </svg>
                  <span class="sr-only">Telegram</span>
              </a>
              
          </div>
      </div>
    </div>
</footer>

  );
};


export default Footer;
